/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React from 'react'
import classNames from 'classnames'
import CardsListingV1 from './components/widgets/cards-listingV1'
import USStockL2ReturnsCalculator from './components/widgets/returns-calculator'
import { TAssetDetailsData } from '@/components/Stocks/Widgets/types'
import {
  TStrapiV4CommonRichTextEditorWidget,
  TStrapiV4PageType,
  TStrapiV4SectionFAQsWidget,
} from '@/stories/strapi-4/common-types'
import CatalogueOverview from '@/components/catalogue/CatalogueOverview'
import CatalogueKeyStats from '@/components/catalogue/CatalogueKeyStats'
import CatalogueManagementTeam from '@/components/catalogue/CatalogueManagementTeam'
import { StrapiV4SectionFAQs } from '@/stories/strapi-4/widget-components/faqs-section/faqs-section'
import NewPerformance from '@/stories/components/Common/PerformanceWidget'
import Valuations from '@/stories/components/INStocksDetail/Valuations'
import WhatExpertsSayWrapper from '@/components/Stocks/Widgets/WhatExpertsSaysWrapper'
import Forecast from '@/components/Stocks/Widgets/Forecast'
import TransposedDataTable from '@/stories/components/DetailPage/TransposedDataTable'
import MFHoldings from '@/stories/components/INStocksDetail/MFHoldings'
import CorporateAnnouncements from '@/components/USStocks/USStocksChildPage/corporate-annoucements'
import INDStocksInsights from '@/components/Stocks/Widgets/INDStocksInsights'
import Infographics from '@/components/Common/Infographics'
import CompanyInfoWrapper from '@/components/INDStocks/DetailPage/CompanyInfoWrapper'
import { TCurrency } from '@/components/catalogue/types'
import CataloguePeerComparison from '@/components/catalogue/CataloguePeerComparison'
import { getCatalogueFaqs } from '@/root/utils/catalogue/investInCatalogue'
import { TRelatedBlogs } from '@/root/utils/articles/types'
import RelatedBlogs from '@/components/Common/relatedBlogs'
import TimelineWidget from '@/components/Stocks/Widgets/TimelineWidget'
import InvestmentStats from '@/components/catalogue/UsL2/Holdings'
import { getHoldingsData } from '@/root/utils/catalogue/getHoldingsData'
import { SectionWrapper } from '@/components/ScrollAwareV2/SectionWrapper'
type Tprops = TAssetDetailsData & {
  stockApiLoading: boolean
  isMobile: boolean | null
  strapiApiResponse?: TStrapiV4PageType | null
  currency: TCurrency
  onCurrencyToggle: (currency: TCurrency) => void
  usStocksRelatedBlogs?: TRelatedBlogs | null
  ticker: string
  containerClassName?: string
  faqs_data?: {
    '5y_stock_return'?: number
    curr_date?: string
  }
  token?: string | null
  meta_info?: {
    currency_symbol?: '$' | '₹'
  }
}

const UsDetailPage = (props?: Tprops) => {
  const {
    catalog = {},
    graph,
    isMobile,
    stockApiLoading,
    metadata,
    strapiApiResponse,
    currency,
    onCurrencyToggle,
    usStocksRelatedBlogs,
    ticker,
    containerClassName,
    market_status = {},
    faqs_data = {},
    token,
    meta_info,
  } = props ?? {}

  const strapiFaqSection = strapiApiResponse?.data.attributes.content.find(
    el => el.__component === 'widgets.faqs-section',
  ) as TStrapiV4SectionFAQsWidget | null | undefined

  const strapiFaqs = strapiFaqSection?.faq_section ?? null

  const strapiAboutSection =
    props?.strapiApiResponse?.data.attributes.content.find(
      el => el.__component === 'widgets.rich-text-editor',
    ) as TStrapiV4CommonRichTextEditorWidget | undefined

  const strapiAboutContent = strapiAboutSection?.rich_text_html

  const {
    entity_basic = {},
    entity_stats = {},
    stock_details,
    linked_collections = [],
  } = catalog
  const { live_price = '', performance = '' } = entity_stats
  const {
    short_name = '',
    ind_key = '',
    socket_path = '',
    exchange = '',
    name = '',
  } = entity_basic

  const {
    research: entityDetailsResearch,
    analyst_forecast,
    stock_peers,
    company_details,
    brands_data,
    mutual_fund_holdings,
    news_items,
    insights_data,
    valuations,
    sp,
    pnl,
    cf,
    fundamental_data = {},
    interest_data = [],
    returns_calculator,
    institutional_holdings,
  } = stock_details ?? {}

  const { consensus = {} } = analyst_forecast ?? {}

  const { management_team } = company_details ?? {}

  const { infographics, corp_announcements } = entityDetailsResearch ?? {}

  const catalogueData = {
    ...entity_basic,
    companyCode: entity_basic.ind_key,
    percent_change: entity_stats.day_change_percentage,
    day_change: entity_stats.day_change,
    last_updated: entity_stats.last_updated_v2,
    ...graph,
    chartData: graph?.candles ?? [],
    live_price,
    fallback: '',
    trading_symbol: entity_basic.symbol ?? ind_key,
    linked_collections,
    ticker,
    isMarketOpen: market_status?.current_market_status !== 'close',
    showLiveMarket: market_status?.current_market_status === 'open',
    delistInfo: {
      is_active: stock_details?.is_active ?? true,
      last_active_date: entity_basic?.last_active_date ?? '',
    },
  }

  const investFromIndiaFaq = getCatalogueFaqs({
    ...entity_basic,
    ...entity_stats,
    ...performance,
    ...stock_details,
    ...faqs_data,
    market_status,
    meta_info,
  })

  const faqSection = {
    heading: strapiFaqs?.heading ?? `FAQs`,
    faqs: [...(investFromIndiaFaq ?? []), ...(strapiFaqs?.faqs ?? [])],
  }

  const holdingsOverview = metadata?.holdings_data?.overview ?? {}
  const holdingsData = getHoldingsData(holdingsOverview)

  const pnlQuarterly = pnl?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'quarterly',
  )
  const pnlAnnual = pnl?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'annual',
  )

  const cfQuarterly = cf?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'quarterly',
  )
  const cfAnnual = cf?.contents?.find(
    el => el?.name?.toLowerCase?.() === 'annual',
  )

  return (
    <div
      className={classNames('flex w-full flex-col gap-y-16', {
        [containerClassName ?? '']: !!containerClassName,
      })}
    >
      <SectionWrapper id="share-price">
        <CatalogueOverview
          {...catalogueData}
          firebase_path={socket_path}
          graphLoading={!!stockApiLoading}
          isMobile={isMobile}
          metadata={metadata}
          showLoginWidget={true}
          exchange={exchange}
          currency={currency}
          onCurrencyToggle={onCurrencyToggle}
          meta_info={meta_info}
          token={token}
          isGraphDisabled={!stock_details?.is_active}
        />

        {!!holdingsOverview?.quantity && (
          <InvestmentStats
            heading="Your Investment Stats"
            data={holdingsData}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="performance">
        {performance && (
          <NewPerformance
            {...performance}
            {...entity_stats}
            meta_info={meta_info}
            marketDataHeading={`${short_name} share price movements today`}
            returnsHeading={`${short_name} Historical Returns`}
            heading={`${short_name} Stock Performance`}
            subheading={`Get live ${short_name} share price, day's high and low, historical returns, and market stats.`}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="fundamentals">
        {!!stock_peers?.length && (
          <CatalogueKeyStats
            stats={stock_peers[0]}
            company_name={short_name}
            fundamental_data={fundamental_data}
            industry_pe_ratio={valuations?.pe_ratio?.industry?.ratio}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="valuation">
        {!!valuations && <Valuations data={valuations} name={short_name} />}
      </SectionWrapper>

      <SectionWrapper id="peers">
        {!!stock_peers?.length && (
          <CataloguePeerComparison
            data={stock_peers}
            ind_key={ind_key}
            heading={
              stock_peers.length === 1
                ? `${short_name} stock Key Stats`
                : `${name} vs Peer Comparison`
            }
            short_name={short_name}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="returns-calculator">
        {returns_calculator && (
          <USStockL2ReturnsCalculator
            widgetData={{
              d: {
                calc: returns_calculator,
                companyName: short_name,
              },
            }}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="analyst-recommendation">
        {consensus?.sentiment && (
          <WhatExpertsSayWrapper
            consensus={consensus}
            company_name={short_name}
            meta_info={meta_info}
            showSource={false}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="target-price">
        {analyst_forecast && (
          <Forecast
            {...analyst_forecast}
            compnany_name={short_name}
            live_price={`${meta_info?.currency_symbol}${live_price}`}
            currencySymbol="$"
            showSource={false}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="sentiment">
        {!!interest_data?.length && (
          <CardsListingV1
            widgetData={{
              d: {
                list: interest_data,
                he: `${short_name} Stock’s Investor Sentiment and Interest`,
              },
            }}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="pnl">
        {!!pnlQuarterly && (
          <TransposedDataTable
            details={{
              contents: [pnlQuarterly],
              display_name: `${name} Quarterly Profit & Loss`,
              display_subtitle: `All numbers in Millions USD`,
            }}
          />
        )}
        {!!pnlAnnual && (
          <TransposedDataTable
            details={{
              contents: [pnlAnnual],
              display_name: `${name} Annual Profit & Loss`,
              display_subtitle: `All numbers in Millions USD`,
            }}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="cf">
        {!!cfQuarterly && (
          <TransposedDataTable
            details={{
              contents: [cfQuarterly],
              display_name: `${name} Quarterly Cash Flow`,
              display_subtitle: `All numbers in Millions USD`,
            }}
          />
        )}
        {!!cfAnnual && (
          <TransposedDataTable
            details={{
              contents: [cfAnnual],
              display_name: `${name} Annual Cash Flow`,
              display_subtitle: `All numbers in Millions USD`,
            }}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="shareholding">
        {!!sp?.contents?.length && (
          <TransposedDataTable
            details={{
              ...sp,
              display_name: `${short_name} Stock Shareholding Pattern`,
              display_subtitle: `All numbers in thousands`,
            }}
          />
        )}
        {mutual_fund_holdings?.length && (
          <MFHoldings
            sectionHeading={`Mutual Funds that own ${short_name} Stock`}
            subheading={`Check out the Mutual Funds with significant holdings in ${short_name}.`}
            data={mutual_fund_holdings}
          />
        )}
        {institutional_holdings?.length && (
          <MFHoldings
            sectionHeading={`Global Institutional Holdings in ${short_name}`}
            data={institutional_holdings}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="corp-action">
        {corp_announcements && (
          <CorporateAnnouncements
            {...corp_announcements}
            company_name={short_name}
            subheading={`View detailed summary of the earnings and dividend history of ${short_name}.`}
            containerClassName="!p-0"
            headingClassName="pb-6 border-b-[0.5px] w-full "
            heading="Corporate Actions"
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="blogs-news">
        {!!usStocksRelatedBlogs?.length && (
          <RelatedBlogs
            heading={`Latest Blogs about ${short_name}`}
            relatedBlogs={usStocksRelatedBlogs}
            isMobile={isMobile}
          />
        )}

        {news_items?.news_timelines && (
          <TimelineWidget
            heading={`${short_name} News & Key Events`}
            {...news_items.news_timelines}
            minwidth="lg:min-w-[57%] xl:min-w-[32%]"
            isMobile={false}
            itemClassName="!m-0"
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="insights">
        {!!insights_data && (
          <INDStocksInsights
            data={insights_data}
            showDesc={true}
            itemClassName="!mb-0"
          />
        )}

        {infographics?.heading && <Infographics {...infographics} />}
      </SectionWrapper>

      <SectionWrapper id="company-info">
        {company_details && (
          <CompanyInfoWrapper
            company_details={company_details}
            name={name}
            full_name={entity_basic.name}
            brands_data={brands_data}
            strapiAboutSection={strapiAboutContent}
          />
        )}

        {!!management_team?.rows?.length && (
          <CatalogueManagementTeam
            management_team={management_team}
            companyName={short_name}
          />
        )}
      </SectionWrapper>

      <SectionWrapper id="faqs">
        {!!faqSection.faqs.length && (
          <StrapiV4SectionFAQs
            faq_section={faqSection}
            variant="v1"
            addFontSize="size-24"
          />
        )}
      </SectionWrapper>
    </div>
  )
}

export default UsDetailPage
